import { PersonPostionGroup } from '@aibees/elephant/feature/search-table-people/types';
import {
  hasNoCompanyDataAvailable,
  normalizeEmploymentType,
} from '@aibees/elephant/utils';
import type { Nullable } from '@aibees/shared/definition';

export function getEmploymentType(item: PersonPostionGroup) {
  return item?.profile_positions?.[0]?.employment_type;
}

function isCompanyNameNA(name: Nullable<string>): boolean {
  if (!name) return true;
  const trimmed = name.trim();
  return trimmed === '' || trimmed.toLowerCase() === 'n/a';
}

export function getWorkHistoryCompanyDisplayInfo(item: PersonPostionGroup): {
  displayName: string;
  color: 'grey.700' | 'grey.400';
} {
  const companyName = item.company?.name ?? null;
  const employmentType = getEmploymentType(item);
  const normalizedEmploymentType = normalizeEmploymentType(employmentType);
  const noCompanyDataAvailable = hasNoCompanyDataAvailable(item.company);

  if (isCompanyNameNA(companyName) && normalizedEmploymentType) {
    return {
      displayName: normalizedEmploymentType,
      color: 'grey.700',
    };
  }

  if (noCompanyDataAvailable) {
    return {
      displayName: 'N/A',
      color: 'grey.400',
    };
  }

  return {
    displayName: companyName ?? 'N/A',
    color: 'grey.700',
  };
}
